import React, { useEffect, useState, useCallback } from 'react';
import {useLocation} from 'react-router-dom';
import { DataGridPro, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { ContentTitle } from '../ui/styled';
import { Auth } from 'aws-amplify';
import BackIcon from '../common/Back/BackIcon';
import PageHeading from '../common/Heading/PageHeading';
import { commonQueryParams } from '../../services/QueryParams/QueryParams';
import { REPORT_WEEKLY_PAROLE_URL, dateFormat } from '../../constants';
import { renderCellExpand } from '../common/GridCell/GridCellExpand';
import { getWeeklyReport } from './services/reportsApi';
import moment from 'moment';

const WeeklyParole = (props) => {
  console.log('WeeklyParole');
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [reportList, setReportList] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1, 
    pageSize: 10,
  });

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    console.log('getUser');
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const fetchData = async () => {    
    setReportList((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = commonQueryParams(
      REPORT_WEEKLY_PAROLE_URL + location.state.startDate + '/' + location.state.endDate + '/' + location.state.countyID,
      null,
      reportList
    );
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const report = await getWeeklyReport({
      commonParams,
      authorization,
    });
    setReportList((prveState) => ({
      ...prveState,
      ...report,
    }));
  };

  const QuickSearchToolbar = () => {
    return (
      <Box pt={1} sx={{ flexGrow: 1, backgroundColor: '#747070' }}>
        <Grid container spacing={1}>
          <Grid item xs={11}>
          </Grid>
          <Grid item xs={1}>  
            <GridToolbarContainer>
              <GridToolbarExport 
                printOptions={{'disableToolbarButton': true }}
                csvOptions={{'fileName': 'WeeklyParole_' + location.state.startDate + '_' + location.state.startDate + '_' + location.state.county}}
              />
            </GridToolbarContainer>
          </Grid>
        </Grid>    
      </Box>  
    );
  };


  const columnsData = [
    {
      field: 'prtLname',
      headerName: 'Last',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'prtFname',
      headerName: 'First',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'prtMname',
      headerName: 'Middle',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'paroleeName',
      headerName: 'Full',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'epdIcnCDC',
      headerName: 'CDC#',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'cntKey',
      headerName: 'Contact',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'aor',
      headerName: 'AOR',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'orgKey',
      headerName: 'Org',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'sapAthAdmDate',
      headerName: 'Admit',
      type: 'date',
      renderCell: (params) => {
        return (
          <Typography>{params.value ? moment(params.value).format(dateFormat) : ''}</Typography>
          );
        },
      flex: 1,
    },
    {
      field: 'sapAthDchDate',
      headerName: 'Discharge',
      type: 'date',
      renderCell: (params) => {
        return (
          <Typography>{params.value ? moment(params.value).format(dateFormat) : ''}</Typography>
          );
        },
      flex: 1,
    },
    {
      field: 'athDchTypDsc',
      headerName: 'Discharge Type',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'cbo_ModID',
      headerName: 'Modality ID',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'modDsc',
      headerName: 'Modality',
      renderCell: renderCellExpand,
      flex: 1,
    },
  ];
  return (
    <>
      <ContentTitle container>
        <Grid item xs={4}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <BackIcon />
            <PageHeading title='Weekly Parole' />
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box style={{ alignItems: 'center' }}>
            <Typography variant='h4' align='center'>{location.state.countyName} County Weekly Parole {location.state.startDate} To {location.state.endDate}</Typography>
          </Box>
        </Grid>
      </ContentTitle>
      <DataGridPro
        autoHeight
        getRowHeight={() => 'auto'}
        columns={columnsData}
        rows={reportList.data}
        getRowId={(row) => row.epdIcnCDC}
        rowCount={reportList.total}
        components={{ Toolbar: QuickSearchToolbar }}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        loading={reportList.isLoading}
      />
    </>
  );
};
export default WeeklyParole;